import { ArrowLeft, RotateCcw, AlertCircle, CheckCircle, Clock, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const Widerrufsrecht = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
          <h1 className="text-4xl font-bold">Widerrufsrecht</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12 space-y-10">
          
          {/* Intro */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <RotateCcw className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900">Widerrufsbelehrung</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Verbraucher haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen einen 
              Vertrag zu widerrufen.
            </p>
          </section>

          {/* Duration */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center">
                <Clock className="w-5 h-5 text-slate-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Widerrufsfrist</h2>
            </div>
            <div className="bg-teal-50 border border-teal-200 rounded-xl p-6">
              <p className="text-teal-800 font-medium">
                Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
              </p>
            </div>
          </section>

          {/* How to exercise */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <Mail className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Ausübung des Widerrufsrechts</h2>
            </div>
            <p className="text-slate-600 leading-relaxed mb-4">
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung 
              (z.B. per E-Mail oder Post) über Ihren Entschluss, diesen Vertrag zu widerrufen, 
              informieren.
            </p>
            <div className="bg-slate-50 rounded-xl p-6">
              <p className="font-semibold text-slate-900 mb-2">Kontakt für Widerruf:</p>
              <p className="text-slate-600">AKW Design</p>
              <p className="text-slate-600">Adrian Wojciechowski</p>
              <p className="text-slate-600">Jakob-Mankel-Straße 20</p>
              <p className="text-slate-600">35781 Weilburg</p>
              <a href="mailto:akw-design@gmx.de" className="text-teal-600 hover:text-teal-700 font-medium mt-2 block">
                akw-design@gmx.de
              </a>
            </div>
          </section>

          {/* Consequences */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center">
                <CheckCircle className="w-5 h-5 text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Folgen des Widerrufs</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen 
              erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag 
              zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns 
              eingegangen ist.
            </p>
          </section>

          {/* Exclusion */}
          <section className="border-t border-slate-200 pt-10">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center">
                <AlertCircle className="w-5 h-5 text-amber-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Ausschluss des Widerrufsrechts</h2>
            </div>
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-6">
              <p className="text-amber-800 leading-relaxed">
                Das Widerrufsrecht erlischt bei Verträgen zur Lieferung von Waren, die nicht 
                vorgefertigt sind und für deren Herstellung eine individuelle Auswahl oder 
                Bestimmung durch den Verbraucher maßgeblich ist oder die eindeutig auf die 
                persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind (z.B. individuell 
                angefertigte Designarbeiten, personalisierte Aufkleber oder Folien).
              </p>
            </div>
          </section>

        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <Link to="/">
            <Button variant="outline" className="rounded-full px-8">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
